export enum CommonPlaceholders {
  Search = 'ScJm',
  CountType = 'S2ry',
  NothingSelectedYet = 'mKp3',
}
